/**
 * InDeep-Net
 * Copyright (C) 2025
 * Authors: Fabien MAREUIL
 *
 * This program is free software: you can redistribute it and/or modify
 * it under the terms of the GNU Affero General Public License as published
 * by the Free Software Foundation, either version 3 of the License, or
 * (at your option) any later version.
 *
 * This program is distributed in the hope that it will be useful,
 * but WITHOUT ANY WARRANTY; without even the implied warranty of
 * MERCHANTABILITY or FITNESS FOR A PARTICULAR PURPOSE.  See the
 * GNU Affero General Public License for more details.
 *
 * You should have received a copy of the GNU Affero General Public License
 * along with this program.  If not, see <https://www.gnu.org/licenses/>.
 */
import { useState } from 'react';
import { updateIsActivated } from './HookStateUpdate.jsx';

export function RangeSlider({ id='rangeid', min = 0, max = 100, onValueChange }) {
    const [value, setValue] = useState(min);

    const handleChange = (event) => {
        const newValue = parseInt(event.target.value, 10);
        setValue(newValue);
        if (onValueChange) {
            onValueChange(newValue);
        }
    };

    const deactiveSubmit = () => {
        console.log(value, "clické")
        updateIsActivated(false)
    }
    const activeSubmit = () => {
        console.log(value, "laché")
        updateIsActivated(true)
    }

    
    const getBubblePosition = () => {
        const percentage = ((value - min) / (max - min)) * 100;
        return `calc(${percentage}% )`; 
    };

    return (
        <div id={id} className="hidden">
            <div className=" w-full m-auto p-2 items-center h-32 justify-center relative">
                <h3 className="font-semibold dark:text-white">ADJUST POCKET VOLUME DETECTION</h3>
                <small className="text-gray-600 dark:text-gray-50">Select the desired pocket volume for InDeep detection</small>
                <div className="mt-5 relative w-full">
                    <div
                        id="bubbleposition"
                        className="absolute top-[-24px] text-white bg-gray-800 rounded px-2 py-1 text-xs font-bold transform -translate-x-1/2"
                        style={{ left: getBubblePosition() }}
                    >
                        {value}
                    </div>
                    <input
                        id="volume-range"
                        type="range"
                        min={min}
                        max={max}
                        value={value}
                        onMouseDown={deactiveSubmit}
                        onMouseUp={activeSubmit}
                        onChange={handleChange}
                        className="w-full appearance-none h-2 bg-gray-200 rounded-full focus:outline-none cursor-pointer"
                    />
                </div>          
                <div className="w-full flex justify-between dark:text-white">
                    <span>{min}</span>
                    <span>{max}</span>
                </div>
                
            </div>
        </div>
    );
}